import app from 'flarum/forum/app';
import Modal from 'flarum/components/Modal';
import Button from 'flarum/components/Button';

import MapModule from '../MapModule';
import getItemUnit from "../../common/util/getItemUnit";
import getUserInfo from "../../common/util/getUserInfo";
import getInfoSize from "../../common/util/getInfoSize";
import getInfoWantedPrice from "../../common/util/getInfoWantedPrice";

export default class infoPromotionImageModal extends Modal {
  static isDismissibleViaBackdropClick = false;
  static isDismissibleViaCloseButton = true;

  oninit(vnode) {
    super.oninit(vnode);
    this.infoID = this.attrs.infoID;
    this.loading = true;
    this.u2diInfoData = [];
    this.infoBaseData = null;

    const u2diUserType0 = app.forum.attribute('u2diUserType0');
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    let apiURL = "u2diInfoList/y";

    if(u2diUserType9===true){
      apiURL = "u2diInfoList/a";
    }

    app.store
      .find(apiURL, {
      itemID:this.infoID
    })
    .catch(() => {})
    .then(this.parseResults.bind(this));
  }

  className() {
    return 'Modal--medium u2diInfoPromotionImageModal';
  }

  title() {
    return "";
  }

  content() {
    if(this.loading){
      return (
        <div>
          <div id="u2diInfoPromotionImageMask">
            {app.translator.trans('ziven-u2di.forum.item-generating-promotion-image')}
          </div>
          <div id="u2diInfoPromotionImageContent" className="Modal-body">
          </div>
        </div>
      );
    }else{
      const u2diUserType9 = app.forum.attribute('u2diUserType9');
      const _this = this;
      const lxdh_wx_qr = this.userInfo.lxdh_wx_qr();
      const wxQR = this.isJsonString(lxdh_wx_qr)?JSON.parse(lxdh_wx_qr):"";
      const wxQRImage = wxQR==="" || wxQR.length===0?"":wxQR[0].path
      const infoSN = this.infoSN = this.infoBaseData.sn();
      const infoCategory = this.infoBaseData.category();

      const option_zcqs = app.translator.trans("ziven-u2di.forum.option-zcqs-"+this.zcxx.option_zcqs);
      const option_lzxz = app.translator.trans("ziven-u2di.forum.option-lzxz-"+this.zcxx.option_lzxz);
      const option_zclb = app.translator.trans("ziven-u2di.forum.option-zclb-"+this.zcxx.option_zclb);
      const infoName = option_zcqs+option_lzxz+option_zclb;

      let infoAreaSize = "";
      let infoAreaUnit = "";
      const option_tdmj = this.zcxx.option_tdmj;
      const option_jzmj = this.zcxx.option_jzmj;
      const option_synx = this.zcxx.option_synx;
      const option_yqjg = this.jjxx.option_yqjg;

      if(infoCategory==="jzwz"){
          infoAreaSize = option_jzmj;
          infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-squre-meter');
      }else if(infoCategory==="tdwz"){
          infoAreaSize = option_tdmj;
          infoAreaUnit = app.translator.trans('ziven-u2di.lib.unit-mu');
      }

      infoAreaSize = getInfoSize(infoAreaSize,"object");

      let infoWantedPrice = getInfoWantedPrice(option_yqjg,"valueOnly");
      let itemUnit = getItemUnit(infoCategory,this.jjxx);

      return (
        <div>
          <div id="u2diInfoPromotionImageMask">
            {app.translator.trans('ziven-u2di.forum.item-generating-promotion-image')}
          </div>
          <div id="u2diInfoPromotionImageContent" className="Modal-body">
            <div className="Form" style="display: flex;">
              <div className="locationSelectMapContainer">
                <MapModule
                  mapClassName = "PromotionImageMapContainer"
                  mapModuleID = "PromotionImageMap"
                  mapWidth = "512px"
                  mapHeight = "512px"
                  mapModuleCallback = {(mapModule) => {
                      _this.mapModule = mapModule;
                      _this.addSelectedLocation();
                      _this.generateImage();
                    }
                  } 
                />
                <div className="u2diPromotionImageQR">
                  <img style="height: 120px;border-radius: 4px;" src={u2diUserType9===true?"":wxQRImage} />
                </div>
              </div>
              <div style="width: 320px;margin-left: 64px;">
                <div className="u2diPromotionImageHeader">资产信息卡</div>
                <div style="display: flex;column-gap: 24px;">
                  <div className="u2diPromotionImageText_tddm">资产<br />代码</div>
                  <div className="u2diPromotionImageText_sn">{infoSN}</div>
                </div>
                <div className="u2diPromotionImageInfo" style="margin-top:32px">
                  <div style="width: 35%;text-align: center;">
                    <div className="u2diPromotionImageInfoTitle">{app.translator.trans('ziven-u2di.forum.item-details-area')}</div>
                    <div className="u2diPromotionImageInfoValue" style="margin-top: 5px;">{infoAreaSize}<span className="u2diItemDetailsInfoValueUnit">{infoAreaUnit}</span></div>
                  </div>
                  <div style="width: 30%;text-align: center;">
                    <div className="u2diPromotionImageInfoTitle">{app.translator.trans('ziven-u2di.forum.item-details-years-limit')}</div>
                    <div className="u2diPromotionImageInfoValue" style="margin-top: 5px;">{option_synx}<span className="u2diItemDetailsInfoValueUnit">{app.translator.trans('ziven-u2di.lib.unit-year')}</span></div>
                  </div>
                  <div style="width: 35%;text-align: center;">
                    <div className="u2diPromotionImageInfoTitle">{app.translator.trans('ziven-u2di.forum.item-details-price')}</div>
                    <div className="u2diPromotionImageInfoValue" style="margin-top: 5px;">{infoWantedPrice}<span className="u2diItemDetailsInfoValueUnit">{itemUnit}</span></div>
                  </div>
                </div>
                <div className="u2diPromotionImageType" style="margin-top:32px">
                  {infoName}
                </div>
                <div className="u2diPromotionImageLogo">
                  <img style="width: 240px;" src="./assets/extensions/ziiven-u2di/promotionImageLogo.png" />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  isJsonString(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
  }

  parseResults(results) {
    [].push.apply(this.u2diInfoData, results);

    this.infoBaseData = this.u2diInfoData[0];
    const infoDetailsData = this.infoBaseData.u2diDetailsData();

    this.userInfo = getUserInfo(app.session.user.id());
    this.zcxx = JSON.parse(infoDetailsData.zcxx());
    this.jjxx = JSON.parse(infoDetailsData.jjxx());
    const option_zcwz = this.zcxx.option_zcwz;
    this.clickedLocation = {position:option_zcwz.position,name:option_zcwz.name,province:option_zcwz.province,city:option_zcwz.city};

    this.mapModule = null;
    this.loading = false;

    m.redraw();
    return results;
  }

  generateImage(){
    const _this = this;
    $(".PromotionImageMapContainer .amap-logo").remove();
    $(".PromotionImageMapContainer .amap-copyright").remove();

    setTimeout(function(){
      const u2diInfoPromotionImageMask = document.getElementById("u2diInfoPromotionImageMask");

      if(u2diInfoPromotionImageMask){
        html2canvas(document.getElementById("u2diInfoPromotionImageContent")).then(function(canvas) {
          const img = canvas.toDataURL('image/png');
          u2diInfoPromotionImageMask.innerHTML = "<img style='height:100%;width:100%' src='"+img+"' />";
       
          $("#u2diInfoPromotionImageContent").remove();

          let link = document.createElement('a');
          link.download = _this.infoSN+'.png';
          link.href = canvas.toDataURL()
          link.click();
        });
      }
    },2000);
  }

  addSelectedLocation(){
    const itemData = this.infoBaseData;
    const itemID = itemData.id();
    const userID = app.session.user.id();
    const itemSN = itemData.sn();
    const itemLat = itemData.lat();
    const itemLng = itemData.lng();
    const itemType = itemData.type();
    const itemCategory = itemData.category();
    const itemUnit = getItemUnit(itemCategory,this.jjxx,false);
    const itemPrice = itemData.price()+" "+itemUnit;
    const itemStatus = itemData.status();
    const itemFlag = itemData.flag();
    let cluster = [];

    let itemLatModifier = 0;
    let itemLngModifier = 0;
    
    if(itemFlag!==1){
      if((app.session.user && userID==app.session.user.id()) || u2diUserType9===true){
        let userInfo = getUserInfo(app.session.user.id());
        let assignedAt = userInfo.assignedAt();
        let key = (itemSN%5)*2+1;
  
        itemLatModifier=(assignedAt[key]/10/100);
        itemLngModifier=(assignedAt[key+1]/10/100);
      }
    }

    let lnglat = [itemLng-itemLngModifier*2,itemLat-itemLatModifier*2];

    cluster.push({
      lnglat:lnglat,
      itemID:itemID,
      userID:userID,
      price:itemPrice,
      type:itemType,
      category:itemCategory,
      status:itemStatus,
      dataType:"promotionImage"
    });

    this.mapModule.setZoomAndCenter(10,lnglat,true);

    this.mapModule.emit('mapAddCluster',{
        cluster : cluster,
    });
  }
}
